import React from 'react'
import { VIEW_MODES } from '_hooks/useViewMode'
import './style.scss'

const SORT_OPTIONS = [
  { key: 'closing', label: 'Closing Soon' },
  { key: 'collection', label: 'Collection Date' },
  { key: 'newest', label: 'Newest Event' },
  { key: 'active', label: 'Most Active' },
]

export default function FilterBar({
  filterBarProps = {},
  viewMode: propViewMode,
  changeViewMode
}) {
  const {
    activeTab = 'active',
    onTabChange,
    currentSort = 'newest',
    onSortChange,
    isSortOpen = false,
    setIsSortOpen,
    sortRef,
  } = filterBarProps

  const viewMode = propViewMode ?? VIEW_MODES.TILE

  const currentSortLabel =
    SORT_OPTIONS.find((item) => item.key === currentSort)?.label || 'Sort'

  return (
    <div className="gd-filter-wrapper">
      <div className="gd-filter-title">EVENTS</div>
      <div className="gd-filter-bar">
        {/* Filter tabs */}
        <div className="gd-filter-tabs">
          <button
            type="button"
            className={`gd-tab ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => onTabChange?.('all')}
          >
            All
          </button>
          <button
            type="button"
            className={`gd-tab ${activeTab === 'active' ? 'active' : ''}`}
            onClick={() => onTabChange?.('active')}
          >
            Active
          </button>
          <button
            type="button"
            className={`gd-tab ${activeTab === 'closed' ? 'active' : ''}`}
            onClick={() => onTabChange?.('closed')}
          >
            Closed
          </button>
        </div>

        {/* Right actions: Sort dropdown & View toggle */}
        <div className="gd-filter-actions">
          {/* Sort dropdown */}
          <div className="mef-sort-wrap" ref={sortRef}>
            <button
              type="button"
              className={`mef-sort-btn ${isSortOpen ? 'open' : ''}`}
              id="gd-sort-btn"
              onClick={() => setIsSortOpen?.((prev) => !prev)}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="8" y1="12" x2="16" y2="12" />
                <line x1="11" y1="18" x2="13" y2="18" />
              </svg>
              <span id="gd-sort-label">{currentSortLabel}</span>
            </button>

            {isSortOpen && (
              <div className="mef-sort-menu" id="gd-sort-menu">
                {SORT_OPTIONS.map((item) => (
                  <div
                    key={item.key}
                    className={`mef-sort-item ${currentSort === item.key ? 'active' : ''}`}
                    data-sort={item.key}
                    onClick={() => onSortChange?.(item.key)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* View toggle (List / Tile) */}
          <div className="mef-view-toggle">
            <button
              type="button"
              id="gd-btn-list"
              className={viewMode === VIEW_MODES.LIST ? 'active' : ''}
              onClick={() => changeViewMode?.(VIEW_MODES.LIST)}
              title="List view"
            >
              <svg width="12" height="12" viewBox="0 0 14 14" fill="currentColor">
                <rect y="1" width="14" height="2" rx="1" />
                <rect y="6" width="14" height="2" rx="1" />
                <rect y="11" width="14" height="2" rx="1" />
              </svg>
            </button>
            <button
              type="button"
              id="gd-btn-tile"
              className={viewMode === VIEW_MODES.TILE ? 'active' : ''}
              onClick={() => changeViewMode?.(VIEW_MODES.TILE)}
              title="Tile view"
            >
              <svg width="12" height="12" viewBox="0 0 14 14" fill="currentColor">
                <rect x="0" y="0" width="6" height="6" rx="1" />
                <rect x="8" y="0" width="6" height="6" rx="1" />
                <rect x="0" y="8" width="6" height="6" rx="1" />
                <rect x="8" y="8" width="6" height="6" rx="1" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
